export const UNITS_REQUEST = "UNITS_REQUEST";
export const UNITS_REQUEST_SUCCEEDED = "UNITS_REQUEST_SUCCEEDED";
export const UNITS_REQUEST_FAILED = "UNITS_REQUEST_FAILED";
